import * as THREE from "three";
import { GroundData } from "../types";

export function createGround(data: GroundData): THREE.Mesh {
  const geo = new THREE.PlaneGeometry(data.size, data.size);
  const mat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(data.color),
    roughness: 0.95,
    metalness: 0.0,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.rotation.x = -Math.PI / 2;
  mesh.receiveShadow = true;
  return mesh;
}
